import Image from "next/legacy/image";
import { useRouter } from "next/router";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../styles/blog.module.css";
function MantraUICard({
  blogData,
  blogCategoryUrlExtension
}) {
  const router = useRouter();
  const {
    t
  } = useTranslation();
  const navigateToBlog = e => {
    e.preventDefault();
    if (blogCategoryUrlExtension && blogCategoryUrlExtension !== "un-categorized") {
      router.push(`/blog/${blogCategoryUrlExtension}/${blogData?.urlExtension}`);
    } else router.push(`/blogs/${blogData?.urlExtension}`);
  };
  return <div className={styles.mantraCard} onClick={navigateToBlog} data-sentry-component="MantraUICard" data-sentry-source-file="mantraUICard.jsx">
      {blogData?.smallImage ? <Image src={blogData?.smallImage ?? ""} alt={t("temple-image")}
    // className={styles.mantraCardImgContainer}
    // style={{
    //   position: "relative",
    //   width: "100%",
    //   // aspectRatio: aspectRatio,
    // }}
    width={"200px"} height={"400px"}
    // layout="fill"
    placeholder="blur" blurDataURL={blogData?.smallImage ?? ""} loading="eager" priority /> : <Image src={blogData?.images.length > 0 ? blogData?.images[0] : ""} alt={t("temple-image")}
    // className={styles.mantraCardImgContainer}
    style={{
      position: "relative",
      width: "100%"
      // aspectRatio: aspectRatio,
    }}
    // width={"100%"}
    // height={"100%"}
    layout="fill" placeholder="blur" blurDataURL={blogData?.images.length > 0 ? blogData?.images[0] : ""} loading="eager" priority />}
    </div>;
}
export default MantraUICard;